var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractDeparture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8320_59458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 16.7894L8.58155 20.7699C8.71687 20.9521 8.95791 21.0203 9.16862 20.936L17.2143 17.718L27.5302 13.607C28.3094 13.2965 29.0829 12.6629 28.9186 11.8404C28.7873 11.1829 28.2936 10.7301 27.7495 10.5078C27.2303 10.2956 26.6556 10.4498 26.1296 10.6443L20.7035 12.6517C20.5453 12.7103 20.3683 12.6851 20.2327 12.5848L11.6909 6.26835C11.5524 6.16591 11.3709 6.14201 11.2106 6.2051L9.84689 6.7417C9.54054 6.86225 9.43228 7.24083 9.62858 7.50511L14.7034 14.3374C14.8989 14.6006 14.7924 14.9776 14.4882 15.0996L9.63271 17.0476C9.48175 17.1081 9.31076 17.0915 9.17432 17.0029L7.20113 15.7222C7.06645 15.6347 6.89797 15.6173 6.74825 15.6753L5.84573 16.0251C5.53775 16.1444 5.42806 16.5243 5.625 16.7894Z",
    fill: "#595959",
    stroke: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 26.75H27.25",
    stroke: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8320_59458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractDeparture);
export default __webpack_public_path__ + "static/media/contract-departure.95b7ce58c2f04996a87db4f3ac77e0e9.svg";
export { ForwardRef as ReactComponent };